


// product details

export const GetSingleProduct = "GetSingleProduct";
export const SingleProductLoadedType = "SingleProductLoadedType";
export const ClearSingleProduct = "ClearSingleProduct";
export const GetRelatedProducts = "GetRelatedProducts";
export const RelatedProductsLoaded = "RelatedProductsLoaded";
export const UpdateActiveProductAttribute = "UpdateActiveProductAttribute";
export const UpdateActiveProductPrice = "UpdateActiveProductPrice";
export const UPDATE_ACTIVE_PRODUCT_AMOUNT = "UPDATE_ACTIVE_PRODUCT_AMOUNT";
export const CheckUserFavourite = "CheckUserFavourite";
export const SetUserFavourite = "SetUserFavourite";
export const SetUserFavouriteId = "SetUserFavouriteId";
export const set_voucher = "set_voucher";
export const set_voucher_percentage = "set_voucher_percentage";
export const set_cart_total_with_voucher = "set_cart_total_with_voucher";
export const CHECK_VOUCHER = "CHECK_VOUCHER";
export const set_voucher_data = "set_voucher_data";
export const ResetStatus ="ResetStatus"



// products list


export const GetProductList = "GetProductList";
export const ProductListLoaded = "ProductListLoaded";
export const ProductListNotFound = "ProductListNotFound";




export const GetAttribtuesListBySubCat = "GetAttribtuesListBySubCat";
export const GetAttribtuesListByCat = "GetAttribtuesListByCat";
export const GetAttribtuesListLoaded = "GetAttribtuesListLoaded";


export const GetFilterList = "GetFilterList";
export const FilterLoaded = "FilterLoaded";
export const SortProducts = "SortProducts";



export const GetBrandsList = "GetBrandsList";
export const BrandsLoaded = "BrandsLoaded";
export const GetBrandsListForCat = "GetBrandsListForCat";


export const GetProductListPaging = "GetProductListPaging";
export const GetProductListPagingLoaded = "GetProductListPagingLoaded";



// checkout
export const SET_CHECKOUT_NOTE = "SET_CHECKOUT_NOTE";


// product details page
export const reserve_item = "reserve_item";
